import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=ff0c9e76"
import script from "./SearchIcon.vue?vue&type=script&lang=ts"
export * from "./SearchIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports